<!-- 现金支付 -->
<template>
	<div class="home">
		<!-- <van-nav-bar
			left-arrow
			fixed
			@click-left="$router.go(-1)">
		</van-nav-bar> -->
		<div class="fail">{{$t('OrderDetail.cashPay')}}</div>
		<div class="failInfo failInfo1">{{$t('OrderDetail.ticket')}}：{{orderDetail.ticket}}</div>
		<div class="failInfo">{{$t('OrderDetail.orderNum')}}：{{orderDetail.order}}</div>
		<div class="failInfo">{{$t('OrderDetail.pricePay')}}：{{sessionStorage.getItem('currency')}}{{orderDetail.final_price}}</div>

		<van-button @click="goOrder()" class="btn" block>{{$t('OrderDetail.checkOrder')}}</van-button>
	</div>
</template>
<script>
export default {
	data () {
		return {
			orderDetail:{},
		};
	},
	created(){
        if(localStorage.onlyCode==localStorage.successCode && localStorage.takeOrderId!==undefined){
            this.getOrderDetail(0);
        }else{
            this.continueOrder();
        }

    },
	methods: {
		getOrderDetail(type){
			this.$axios({
                method: 'PUT',
                url: this.$build+'/api/order/'+localStorage.takeOrderId+'/takeIndex',
            }).then(res => {
                if(res.data.status==200){
                	this.orderDetail=res.data.data;
                	if(type == 1){
                		var self = this;
						setTimeout(()=>{
							self.setGoto();
						},500)
                	}
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
		},
		goOrder(){
			if(localStorage.onlyCode){
				if(localStorage.onlyCode==localStorage.successCode && localStorage.takeOrderId!==undefined){
					this.getOrderDetail(1);
				}else{
					this.$toast({
						type:'fail',
						message:this.$t('OrderDetail.noPayOrder'),
					});
					var self = this;
					setTimeout(()=>{
						self.continueOrder();
					},500)
				}
			}else{
				this.$toast({
					type:'fail',
					message:this.$t('OrderDetail.noPayOrder'),
				});
				var self = this;
				setTimeout(()=>{
					self.continueOrder();
				},500)
			}
		},
		setGoto(){
			if(this.orderDetail.status<2){
            	this.$toast({
					type:'fail',
					message:this.$t('OrderDetail.plsPay'),
				});
				var self = this;
				setTimeout(()=>{
					self.$router.push('/TakeCartDetail');
				},500)
            }else{
				localStorage.setItem('isPay',true);
				this.$router.push('/TakeOrderDetail/'+localStorage.takeOrderId);
            }
		},
    	// 在下一单，重新获取唯一标识
	    continueOrder(){
	    	this.$axios({
	    		method:'get',
	    		url:this.$build+'/api/shopcart/create',
	    	}).then(res=>{
	    		console.log(res)
	    		if(res.data.status==200){
    				localStorage.setItem('onlyCode',res.data.code)
    				var vm = this;
                    // 跳转到菜品页面
                    setTimeout(()=>{
                    	vm.$router.push('/TakeDishes')
                    },500)
                }else{
                	for (var item in res.data.error) {
                		this.$toast({
                			type:'fail',
                			message:res.data.error[item],
                		});
                	}
                }
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('common.message'),
            	});
            });
        },
    },
}

</script>
<style scoped>
/deep/ .van-nav-bar .van-icon{
	font-size: 26px;
	color: #fff;
}
.home{
	width: 100%;
	height: 100vh;
	background-color: #fff;
}
.fail{
	text-align: center;
	margin-top:100px;
	line-height: 40px;
	font-size: 30px;
	color: #2f75f4;
	font-weight: bold;
	background: #fff;
}

.failInfo{
	text-align: center;
	margin-top:10px;
	line-height: 40px;
	font-size: 30px;
	color: #2f75f4;
	font-weight: bold;
	background: #fff;
}
.failInfo1{font-size: 30px;color: #ff0000; }
.btn{
	background: #2f75f4;
	color: #fff;
	margin:30px auto;
	width: 50%;
	border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/takeAway/TakeCashPayment.vue